import { render } from "./CTAButton.vue?vue&type=template&id=9ee44102&scoped=true"
import script from "./CTAButton.vue?vue&type=script&lang=js"
export * from "./CTAButton.vue?vue&type=script&lang=js"

import "./CTAButton.vue?vue&type=style&index=0&id=9ee44102&scoped=true&lang=scss"

import exportComponent from "/home/marcin/www/orchidea-event-services/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee44102"]])

export default __exports__